export const BACKGROUNDCOLOR = "";
export const FOREGROUNDCOLOR = "#4C4C4C";
export const ForegroundColor = "#4C4C4C";
export const NAVBARBACKGROUNDCOLOR = "#F3F6F4";
